module.exports = __webpack_public_path__ + "static/media/original-preview.78f2a3db.png";